import { render } from "./CitySelector.vue?vue&type=template&id=645ecb57&scoped=true"
import script from "./CitySelector.vue?vue&type=script&lang=js"
export * from "./CitySelector.vue?vue&type=script&lang=js"

import "./CitySelector.vue?vue&type=style&index=0&id=645ecb57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645ecb57"]])

export default __exports__